<template>
  <label :class="{'has-unknown-image': option.skipThisStep}">
    <img
      v-if="option.image && option.image.src"
      :src="option.image.src.url"
      :srcset="option.image.srcset ? option.image.srcset : ''"
      sizes="(max-width: 20.625em) 22vw, (max-width: 34em) 22vw, (max-width: 46.875em) 21vw, (max-width: 61.9375em) 21vw, (max-width: 68.75em) 13vw, 21vw"
      :alt="option.label"
      :width="option.image.width"
    />
    <span :class="{'no-image': noOptionImage, 'skip-this-step': option.skipThisStep}" class="label">
      <div class="radio-input-container" :class="{'no-image': noOptionImage}">
        <input
          type="radio"
          v-model="internalSelection"
          @change="emitUpdate"
          :name="fieldName"
          :value="option.internal_id"
          :key="option.internal_id"
          :ref="`radio_${option.internal_id}`"
          :class="{'no-image': noOptionImage}"
        />
    </div>
      <span :class="{'no-image': noOptionImage, 'has-description': option.copy}">
        {{ option.label }}
        <em v-if="option.price && showConfiguratorPricing" class="option-price">
          {{ '[' + currencyFormatter(option.price) + ']' }}
        </em>
      </span>
    </span>
    <i class="option-copy" v-if="option.copy">{{ option.copy }}</i>
  </label>
</template>

<script>
import EventBus from "../../../event_bus";
import currencyFormatter from "../../../currency_formatter.js";

export default {
  props: ["option", "selection", "showConfiguratorPricing"],
  mounted() {
    EventBus.$on("step-option-cleared", (inputRef) => {
      if (this.$refs[inputRef]) {
        this.$refs[inputRef].checked = false;
      }
    });
  },
  watch: {
    selection: {
      handler: function(value) {
        this.internalSelection = value ? value.internal : null;
      },
    },
  },
  data() {
    return {
      currencyFormatter,
      internalSelection: this.selection ? this.selection.internal :  null,
    };
  },
  methods: {
    emitUpdate() {
      this.$emit(
        "step-option-selected",
        this.option.step_id,
        { external: this.option.sku, internal: this.option.internal_id },
        this.option.price,
      );
    },
  },
  computed: {
    fieldName() {
      return `step_${this.option.step_id}`;
    },
    noOptionImage() {
      return !this.option || !this.option.image || !this.option.image.src;
    },
  },
};
</script>
